import { Button, Link, Modal, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { staffCompanyPath } from "@oysterhr/router"
import { Link as RouterLink } from "react-router-dom"
import { companyUnpaidInvoicesPath } from "../../utils/routeHelpers/companyUnpaidInvoicesPath"
import { FraudSection } from "./components/FraudSection"
import { RestrictionSection } from "./components/RestrictionSection"
import { PaymentStatusSection } from "./components/PaymentStatusSection"
import { StaffInvoicingBadDebtCompanyUnpaidInvoicesQuery } from "../../gql/graphql"

interface Props {
  onClose: () => void
  company: NonNullable<StaffInvoicingBadDebtCompanyUnpaidInvoicesQuery["company"]>["customer"]
}

export const CompanyRestrictionModal = ({ onClose, company }: Props) => {
  const { t } = useTranslation("invoices/CompanyPaymentStatusSection", {
    keyPrefix: "customerRestrictionModal",
  })

  const { paymentsSettings, unpaidInvoicesAmount } = company

  return (
    <Modal isOpen onRequestClose={onClose} data-testid="company-restriction-modal">
      <Modal.Header>{t("title")}</Modal.Header>
      <Modal.Content>
        <div className="space-y-6">
          <div className="space-y-2">
            <Text size="small" className="font-semibold">
              {t("customer")}
            </Text>
            <Link to={staffCompanyPath(company.id ?? "")} className="font-medium">
              {company.name}
            </Link>
          </div>
          <PaymentStatusSection
            unpaidInvoicesAmount={unpaidInvoicesAmount}
            badDebtCategory={paymentsSettings?.badDebtCategory}
          />
          <RestrictionSection restricted={paymentsSettings?.restricted} />
          <FraudSection flaggedAsFraudster={paymentsSettings?.flaggedAsFraudster} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button variation="borderless" onClick={onClose}>
          {t("actions.cancel")}
        </Button>
        <Button
          as={RouterLink}
          to={companyUnpaidInvoicesPath({ companyId: company.id ?? "", isStaff: true })}
        >
          {t("actions.viewUnpaidInvoices")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
